//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    leftXsImage: {
      type: Object,
      default: null,
    },
    leftMdImage: {
      type: Object,
      default: null,
    },
    leftLgImage: {
      type: Object,
      default: null,
    },
    leftXlImage: {
      type: Object,
      default: null,
    },
    leftXsX2Image: {
      type: Object,
      default: null,
    },
    leftMdX2Image: {
      type: Object,
      default: null,
    },
    leftLgX2Image: {
      type: Object,
      default: null,
    },
    leftXlX2Image: {
      type: Object,
      default: null,
    },
  },
  computed: {
    srcSetObject() {
      const leftXsImage = this.leftXsImage;
      const leftXsX2Image = this.leftXsX2Image;
      const leftMdImage = this.leftMdImage;
      const leftMdX2Image = this.leftMdX2Image;
      const leftLgImage = this.leftLgImage;
      const leftLgX2Image = this.leftLgX2Image;
      const leftXlImage = this.leftXlImage;
      const leftXlX2Image = this.leftXlX2Image;

      const xsUrl = leftXsImage && leftXsImage.url;
      const xsX2Url = leftXsX2Image && leftXsX2Image.url;
      const mdUrl = leftMdImage && leftMdImage.url;
      const mdX2Url = leftMdX2Image && leftMdX2Image.url;
      const lgUrl = leftLgImage && leftLgImage.url;
      const lgX2Url = leftLgX2Image && leftLgX2Image.url;
      const xlUrl = leftXlImage && leftXlImage.url;
      const xlX2Url = leftXlX2Image && leftXlX2Image.url;

      const xs = xsUrl ? `${xsUrl} 1x` : null;
      const xsX2 = xsX2Url ? `${xsX2Url} 2x` : null;
      const md = mdUrl ? `${mdUrl} 1x` : null;
      const mdX2 = mdX2Url ? `${mdX2Url} 2x` : null;
      const lg = lgUrl ? `${lgUrl} 1x` : null;
      const lgX2 = lgX2Url ? `${lgX2Url} 2x` : null;
      const xl = xlUrl ? `${xlUrl} 1x` : null;
      const xlX2 = xlX2Url ? `${xlX2Url} 2x` : null;

      return Object.entries({
        xs: [xs, xsX2],
        md: [md, mdX2],
        lg: [lg, lgX2],
        xl: [xl, xlX2],
      }).reduce(
        (acc, [key, value]) => ({
          ...acc,
          [key]: value.filter((i) => i).join(', '),
        }),
        {},
      );
    },
  },
};
